module.exports = __webpack_public_path__ + "img/pkg-type.bb4dcef1.svg";